// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2qc6A","label":"Category_label__wk5Qa","content":"Category_content__MMUkU","header":"Category_header__3WT83","location":"Category_location__3p5Vl"};